import React from 'react';
import { IBlockData } from '../../../typings';
import { BasicType } from '../../../constants';
import { merge } from 'lodash';
import { createBlock, t } from '../../../utils';
import { BasicBlock } from '../../../components/BasicBlock';

export type IRaw = IBlockData<{}, { content: string }>;

export const Raw = createBlock<IRaw>({
    get name() {
        return t('Raw');
    },
    type: BasicType.RAW,
    create: (payload: any) => {
        const defaultData: IRaw = {
            type: BasicType.RAW,
            data: {
                value: {
                    content: '<% if (user) { %>',
                },
            },
            attributes: {},
            children: [],
        };
        return merge(defaultData, payload);
    },
    validParentType: [
        BasicType.PAGE,
        BasicType.WRAPPER,
        BasicType.SECTION,
        BasicType.GROUP,
        BasicType.COLUMN,
        BasicType.HERO,
    ],
    render(params: any) {
        return (
            <BasicBlock
                params={params}
                tag='mj-raw'
            >
                {params.data.data.value.content}
            </BasicBlock>
        );
    },
});
